import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gdx-permission-denied',
    templateUrl: './permission-denied.component.html',
    styleUrls: ['./permission-denied.component.scss'],
    standalone: false
})
export class PermissionDeniedComponent {}
